export default __webpack_public_path__ + "static/media/UBOX 4000.df6b3bba.jpg";